import http from './axios-external'

export const getCep = (cep) => {
   return http.get(`https://viacep.com.br/ws/${cep}/json/`);
}
